import React from "react";
import { Link, Route, Routes, useMatch, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListIntegration from "./views/listIntegration";
import CreateIntegration from "./views/createIntegration";
import EditIntegration from "./views/editIntegration";
// import ViewIntegration from "./views/viewIntegration";
// import PushManually from "./views/pushManually";
import "../../style.scss";
import { useAppContext } from "../../../../../../AppContext";

function MozrestIntegrations() {
  const match = useMatch("/app/user/*");
  const location = useLocation();
  // const basePath = match ? match.pathname.split("/*")[0] : "/app/user";
  const basePath = "/app/user";
  const { chimeraserv, user, components } = useAppContext();
  const props = { chimeraserv, user, components };
  const title = "Manage User | Chimera Solutions | Insights";

  const routes = [
    {
      name: "ListIntegration",
      path: "list",
      auth: true,
      level: [0, 1],
      component: ListIntegration,
    },
    {
      name: "CreateIntegration",
      path: "create",
      auth: true,
      level: [0, 1],
      component: CreateIntegration,
    },
    // {
    //   name: "ViewIntegration",
    //   path: "view/:id",
    //   auth: true,
    //   level: [0, 1],
    //   component: ViewIntegration,
    // },
    {
      name: "EditIntegration",
      path: "edit/:id",
      auth: true,
      level: [0],
      component: EditIntegration,
    },
    // {
    //   name: "Push",
    //   path: "push/:id",
    //   auth: true,
    //   level: [0],
    //   component: PushManually,
    // },
  ];

  // Helper to check if user is allowed for a route
  const isAllowed = (route) => {
    if (!route.auth) return true;
    return route.level.includes(props.user.data.level);
  };

  return (
    <div className="viewContainer">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className="common-actions">
        {[0, 1].includes(props.user.data.level) ? (
          <Link to="/app/integrations/create" className="action-btn">
            <FontAwesomeIcon className="icon" icon={["fas", "plus"]} /> Create
            New Integration
          </Link>
        ) : (
          <div />
        )}
        <Link to="/app/integrations/list" className="action-btn">
          List of Integrations
        </Link>
      </div>
      <div className="viewBody">
        <Routes>
          <Route
            index
            element={
              <ListIntegration
                user={props.user}
                chimeraserv={props.chimeraserv}
                components={props.components}
              />
            }
          />
          {/* <Route
            path={basePath}
            element={
              <ListUser
                user={props.user}
                chimeraserv={props.chimeraserv}
                components={props.components}
              />
            }
          /> */}
          {routes.map((route, key) =>
            isAllowed(route) ? (
              <Route
                key={key}
                path={route.path}
                element={
                  <route.component
                    user={props.user}
                    chimeraserv={props.chimeraserv}
                    components={props.components}
                  />
                }
              />
            ) : (
              <Route
                key={key}
                path={route.path}
                element={
                  props.components.setting[0].component
                    ? React.createElement(props.components.setting[0].component)
                    : null
                }
              />
            )
          )}
          <Route
            path="*"
            element={
              props.components.setting[0].component
                ? React.createElement(props.components.setting[0].component)
                : null
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default MozrestIntegrations;
